import { styled } from "@mui/material";

export const OneRepMaxChartHeaderRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
  padding: theme.spacing(0, 2),
}));

export const OneRepMaxChartHeaderEntries = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  columnGap: theme.spacing(2),
}));
